/* eslint-disable standard/no-callback-literal */
import axios from "axios";

// eslint-disable-next-line no-unused-vars
var callback;

var http = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token")
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    }
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        })
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        })
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    }
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function getListConsultation(params, callback) {
    const authToken = JSON.parse(localStorage.getItem("token")).value;
    const options = {
        headers: {
            Authorization: "Bearer " + authToken,
        },
    };

    http.get("konsul/admin/list-konsul", {
        params: {
            page: params.page,
            size: params.per_page,
            sort: params.sortMode,
            student_email: params.student_email,
            teacher_name: params.teacher_name,
            subject: params.subject_name,
            status: params.status,
            rating: params.rating,
            total_session: params.total_session,
            date: params.data,
            date_to: params.end_date,
            date_from: params.start_date,
        },
        ...options,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    getListConsultation,
};



// WEBPACK FOOTER //
// ./src/modules/konsul/services/konsul.js